import dayjs from '../../dayjs/dayjs_timezone';

// Returns
export const parsedSearchSettings = () => {
  const searchSettings = (window.bta && window.bta.searchSettings) || {};
  const cutOffDays = searchSettings.mindate || 0;
  const minRangeDays = parseInt(searchSettings.min_range || 0, 10);
  const maxRangeDays = parseInt(searchSettings.max_range || 0, 10);

  return { cutOffDays, minRangeDays, maxRangeDays };
}

// Returns the minimum allowed start date by adding cutoff days to today
export const getMinStartDate = (cutOffDays) => {
  const days = parseInt(cutOffDays || 0, 10);
  if (days > 0) {
    return dayjs().add(days, 'days');
  }
  return dayjs();
};

// Calculates default date range respecting cutoff, min_range, and max_range settings
// Logic: use min_range if set, otherwise use max_range capped at 7, otherwise default to 7 days
export const getDefaultSearchDateRange = (cutOffDays, minRangeDays = 0, maxRangeDays = 0) => {
  const startDate = getMinStartDate(cutOffDays);
  const minRange = parseInt(minRangeDays || 0, 10);
  const maxRange = parseInt(maxRangeDays || 0, 10);
  const rangeDays = minRange || (maxRange ? Math.min(maxRange, 7) : 7);
  return {
    start: startDate,
    finish: startDate.clone().add(rangeDays, 'days'),
  };
};
